import { render, staticRenderFns } from "./DeskStatus.vue?vue&type=template&id=61dfe038"
import script from "./DeskStatus.vue?vue&type=script&lang=js"
export * from "./DeskStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports